























































import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class RejectForm extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('documentComment', {}) comment!: any;

  @Prop({}) loading!: boolean;

  @Prop({}) urlFileName!: string;

  @Prop({}) urlFile!: string;

  public close() {
    this.$emit('cancel');
  }

  public reject() {
    this.$emit('decline');
  }

  get canReject() {
    return this.comment.comment !== '';
  }
}
